<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { auth } from './firebase';
import { useAuthStore } from './stores/auth';

const router = useRouter();
const authStore = useAuthStore();

onMounted(() => {
  auth.onAuthStateChanged((user) => {
    if (user) {
      authStore.user = user;
      if (router.currentRoute.value.path === '/login') {
        router.push('/');
      }
    } else {
      authStore.user = null;
      if (router.currentRoute.value.meta.requiresAuth) {
        router.push('/login');
      }
    }
  });
});
</script>

<template>
  <router-view />
</template>